<template>
  <!-- Comment count badge -->
  <v-btn
    v-if="commentCount > 0"
    variant="flat"
    color="amber-darken-1"
    size="x-small"
    class="mr-2"
    prepend-icon="mdi-comment-multiple"
    @click.stop="openCommentDialog"
  >
    <span class="comment-count">{{ commentCount }}</span>
  </v-btn>

  <!-- Add comment button if no comments yet -->
  <v-btn
    v-else
    variant="text"
    color="grey"
    size="x-small"
    class="mr-2"
    prepend-icon="mdi-comment-plus-outline"
    @click.stop="openCommentDialog"
  />
</template>

<script setup>
import { computed, watch } from "vue";
import { useFormsStore } from "@/stores/formsStore";

const props = defineProps({
  item: {
    type: Object,
    required: true,
  },
  commentableType: {
    type: String,
    required: true,
  },
});

const formsStore = useFormsStore();

// Simple comment count - only use object's comments_count property
const commentCount = computed(() => {
  // Use report's comments_count (updated via ActionCable)
  const count = Number(props.item.comments_count) || 0;
  console.log("CommentButton: Using item.comments_count:", count);
  return count;
});

// Watch for real-time updates to the item's comments_count
watch(
  () => props.item.comments_count,
  (newCount) => {
    console.log(
      `CommentButton: Comments count updated for ${props.item.id} - Count: ${newCount || 0}`,
    );
  },
);

// Simply open dialog - no fetching needed
function openCommentDialog() {
  console.log(
    "Opening comment dialog for",
    props.commentableType,
    props.item.id,
  );

  formsStore.edit({
    type: "comments",
    item: {
      type: props.commentableType,
      id: props.item.id,
      // Pass the full report object if it's a Report
      ...(props.commentableType === "Report" && { report: props.item }),
    },
  });
}
</script>

<style scoped>
/* Comment button styling - let Vuetify handle most of it */

/* 📱 MOBILE-ONLY: Minor mobile adjustments */
@media (max-width: 599px) {
}
</style>
